// extracted by extract-css-chunks-webpack-plugin
module.exports = {"singleColumnPage":"AdminUsers__singleColumnPage___14cnU","pageBody":"AdminUsers__pageBody___1C8At","usersTable":"AdminUsers__usersTable___3a9AF","flagCell":"AdminUsers__flagCell___i2K-s"};
    if(module.hot) {
      // 1751719783031
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  